import { render, staticRenderFns } from "./EventUpdate.vue?vue&type=template&id=f37c2710&scoped=true&"
import script from "./EventUpdate.vue?vue&type=script&lang=js&"
export * from "./EventUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37c2710",
  null
  
)

export default component.exports